import meta from './meta'
import mix from './mix'
import utils from './utils'
import getterSetter from './getterSetter'
import method from './method'
import mixin from './mixin'

export default mixin;
export {meta,mix,utils,getterSetter,method}